import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type TJsonQuery, term, terms } from '@/packages/JsonQuery';
import { type SortType } from '@/packages/api-models/common/json_query';

import { type MapBounds } from '../mapConfiguration/slice';

export type TPageLoadMode = 'default' | 'infinity';

export type JsonQueryInitialState = {
  filters: TJsonQuery;
  page: number;
  needUpdateQueryKey: boolean;
  queryKey: string[];
  sort: SortType;
};

const jsonQueryInitialState: JsonQueryInitialState = {
  filters: { _type: 'flatsale', engine_version: term(2), region: terms([1]) },
  page: 1,
  needUpdateQueryKey: false,
  queryKey: ['page', '1'],
  sort: 'default',
};

export const { reducer: jsonQueryReducer, actions: jsonQueryActions } = createSlice({
  initialState: { ...jsonQueryInitialState },
  name: 'jsonQuery',
  reducers: {
    setFilters(state, action: PayloadAction<TJsonQuery>) {
      state.filters = action.payload;
    },
    updateBbox(state, action: PayloadAction<MapBounds>) {
      state.filters.bbox = term(action.payload);
    },
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setPageWithUpdateQueryKey(state, action: PayloadAction<number>) {
      state.page = action.payload;
      state.needUpdateQueryKey = true;
    },
    incrementPage(state) {
      state.page += 1;
    },
    setSort(state, action: PayloadAction<SortType>) {
      state.sort = action.payload;
    },
    setSortWithPageReset(state, action: PayloadAction<SortType>) {
      state.sort = action.payload;
      state.page = jsonQueryInitialState.page;
    },
    setQueryKey(state, action: PayloadAction<string>) {
      state.queryKey = ['page', action.payload];
    },
    setNeedUpdateQueryKey(state, action: PayloadAction<boolean>) {
      state.needUpdateQueryKey = action.payload;
    },
  },
});
